export interface IMapMarker {
  id: string;
  lat: number;
  lng: number;
  icon: string;
  isSelected: boolean;
  loading: boolean;
  height: number;
  width: number;
  /** GB - this will allow us to also have a really custom
   * info window in addition to just a simple string
   */
  infoWindowContent: JSX.Element | string;
  infoWindowOpen: boolean;
  name: string;
  isCustomMarker: boolean;
  brandId: string;
  latlng: google.maps.LatLng;
}

export class MapMarker implements IMapMarker {
    constructor(
        id: string,
        lat: number,
        lng: number,
        icon: string,
        isSelected: boolean,
        loading: boolean,
        height: number,
        width: number,
        infoWindowContent: JSX.Element | string,
        infoWindowOpen: boolean,
        name: string,
        isCustomMarker = true,
        brandId: string = null,
    ) {
        this.id = id;
        this.lat = lat;
        this.lng = lng;
        this.icon = icon;
        this.isSelected = isSelected;
        this.loading = loading;
        this.height = height;
        this.width = width;
        this.infoWindowContent = infoWindowContent;
        this.infoWindowOpen = infoWindowOpen;
        this.name = name;
        this.isCustomMarker = isCustomMarker;
        this.brandId = brandId;
        this.latlng = new google.maps.LatLng(lat, lng);
    }
  //TODO: GB - make get / set methods on this instead of making everything public
  public id = "";
  public lat = 0;
  public lng = 0;
  public icon = "";
  public isSelected = false;
  public loading = false;
  //TODO: GB - need a "smart" default height / width
  public height = 0;
  public width = 0;
  public infoWindowContent: null | string | JSX.Element = null;
  public infoWindowOpen = false;
  public name = "";
  public isCustomMarker = true;
  public brandId = null;
  public latlng = null;
}
